const gameClaims = [
	{
		path: '/community/games/claims',
		name: 'community-game-claims-list',
		component: () => import('@/views/community/game-claims/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,moderation',
		},
	},
]

export default gameClaims
